<template>
    <div class="d-flex justify-center fill-height page">
        <v-container class="d-flex align-center justify-center flex-column fill-height mx-auto px-lg-7 px-6" :class="{'justify-center': pcOnly}">
            <v-card class="bordered mt-6 rounded mt-lg-0" :class="{'w-100': phoneOnly}">
                <div class="d-flex align-stretch">
                    <div class="form-wrapper">
                        <v-card-text>
                            <div class="d-flex justify-center mb-4">
                                <logo height="75" animation />
                            </div>
                            <register-form :loading="loading" @register="registerAction" />

                            <div class="mt-2 details-text text-center">
                                <v-btn x-small text color="muted" :to="{name: 'terms'}">Terms And Conditions</v-btn>
                            </div>

                            <div class="medium-text mx-auto mb-2 mt-5 text-center">
                                <v-divider class="my-5"></v-divider>
    
                                <div class="mb-2 details-text muted--text">Already have an account ?</div>
                                <v-btn dense small outlined block :to="{name: 'login'}" :disabled="loading" class="primary--text px-1">Login</v-btn>
                            </div>
                        </v-card-text>

                    </div>
                </div>
            </v-card>
        </v-container>
        <slot name="footer" />
    </div>
</template>
<script>

// @ is an alias to /src
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import { resolveTargetRoute } from '@/helpers/redirect-query'

import RegisterForm from '@/components/custom/register-form'

export default {
    name: 'register',
    beforeRouteEnter(to, from, next){
        next((vm)=>{
            if (from && from.name === 'login'){
                vm.$store.dispatch('addSnackMsg', { show: false, text: '', msgBar: false });
            }
        });
    },
    data(){
        return {

            loading: false,
        };
    },
    components: {RegisterForm},
    computed:{
        ...GlobalComputed,
    },
    methods: {
        registerAction(data){
            this.loading = true;
            this.$store.dispatch('addSnackMsg', { show: false, text: '', msgBar: false });

            this.$store.dispatch('registerAction', data).then((resolveData)=>{
                this.loading = false;
                if (resolveData.message){
                    this.showMsg(resolveData.message, 'success');
                }
                if (resolveData.redirect){
                    this.$router.push({name: 'confirm'});
                }else{
                    this.$router.push(resolveTargetRoute(this.$route.query) || {name: 'home'});
                }
            }).catch(error=>{
                this.loading = false;
                if (error.response && error.response.status === 422){
                    // coming errors from backend
                    let errors = error.response.data.errors;
                    this.showMsg(errors[Object.keys(errors)[0]][0]);
                }else{
                    this.showMsg('Error occurred during creating your account');
                }
            })
        },
        
        showMsg(text, color = 'error', timeout = 4000){
            this.$store.dispatch('addSnackMsg', {show: true, text: text, color: color, timeout: timeout});
        },
        
        ...GlobalMethods,
        
    },
    watch: {
        
    },
    mounted(){
        
    }
}
</script>

<style lang="scss" scoped>
    .page{
        background-image: url(/img/_background.png);
        background-size: cover;
        background-position: top center;
    }
    .form-wrapper{
        @media(min-width: 960px){
            width: 500px;
        }
    }

</style>

<style lang="scss">
.vue-tel-input-vuetify{
    .country-code{
        margin-right: 6px;
    }
}
</style>